/**
 * Typ wyliczeniowy (Enum) określający precyzyjnie warstwę infrastruktury,
 * w której wystąpił błąd konfiguracji lub komunikacji.
 */
export enum VetineoConfigurationErrorType {
  /** Błąd po stronie systemu Vetineo. */
  VETINEO,

  /** Błąd po stronie Sitesbi
   */
  SITESBI,

  /** * Błąd bezpośrednio związany z bazą danych MSQL.
   */
  MSQL
}

/**
 * Model reprezentujący pojedynczy incydent / błąd konfiguracyjny
 * wykryty podczas próby połączenia lub synchronizacji między systemami.
 */
export class VetineoConfigurationError {

  /** Surowy kod błędu.
   */
  public value: string;

  /** Przetłumaczony, przyjazny dla człowieka komunikat o błędzie
   */
  public translation: string;

  /** Przypisanie błędu do konkretnej warstwy architektonicznej (Vetineo, Sitesbi, MSQL). */
  public type: VetineoConfigurationErrorType;

}

/**
 * Obiekt transferu danych (DTO) używany podczas definiowania ustawień Vetineo w Sitesbi.
 */
export class VetineoConfigurationErrorDto {

  /** Klucz licencyjny.
   */
  public licenceKey: string;

  /** Tablica zebranych błędów otrzymana jako odpowiedź z Sitesbi
   */
  public sitesbiResults: VetineoConfigurationError[];

}
